import React, { useState, useEffect } from 'react';
import TextLoop from "react-text-loop";
import { trackEvent } from "../../services/analytics";
import {Navbar, Nav, Image, NavDropdown, } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import LandingPageNav from "../../components/navbars/landingPage";
import FooterLandingPage from "../../components/footers/landing";
import Section from "../../components/landingPage/sections";
import {Helmet} from "react-helmet";

const Landing = (props) => {
    const { t, i18n } = useTranslation();
    const [ lang, setLang ] = useState('id');
    const [ loading, setLoading ] = useState(true);

    useEffect(()=> {
        let lng = lang;
        if (props.match.params.lang) {
            lng = props.match.params.lang
        } else if (localStorage.getItem('language')){
            lng = localStorage.getItem('language')
        }
        setLang(lng);
        setLoading(false);
        i18n.changeLanguage(lng)
        localStorage.setItem('language', lng);
    },[]);

    const onClickSignIn = (name) => {
        trackEvent('Click',{
            action: "track",
            category: "Buttons",
            label: name,
            event: "Click"
        })
    };

    const onClickSignUp = (name) => {
        trackEvent('Click',{
            action: "track",
            category: "Buttons",
            label: name,
            event: "Click"
        })
    };

    const mobileApp = [
        'Cocok untuk pengiriman 1-10 order per hari',
        'Dapat digunakan melalui perangkat handphone Anda',
        'Akses ke pengiriman reguler, next day dan same day'
    ]

    const webApp = [
        'Cocok untuk pengiriman 10-100 order per hari',
        'Dapat diakses oleh tim Anda dari berbagai perangkat',
        'Pengiriman reguler, next day dan same day',
        'Pengiriman instan',
        'Cetak label pengiriman otomatis',
        'Biaya kirim sesuai dengan harga dari masing-masing kurir'
    ]

    const plugins = [
        'Cocok untuk bisnis yang memiliki channel penjualan e-commmerce',
        'Terintegrasi otomatis untuk mengatur pengiriman Anda',
        'Terintegrasi otomatis dengan berbagai channel penjualan'
    ]

    const mapsSearchAPI = [
        'Pencarian untuk kodepos, nama kecamatan, kota bahkan negara',
        'Tidak perlu menyimpan data peta ',
        'Diupdate setiap harinya oleh tim Maps Biteship'
    ]

    const ratesAPI = [
        'Berlaku untuk pengiriman instan, same day, next day dan reguler',
        'Berlaku untuk pengiriman internasional',
        'Dapat dicari hanya menggunakan kodepos',
        'Bandingkan harga pengiriman antara kurir pengiriman',
        'Dapat digunakan hanya dengan kordinat'
    ]

    const trackingAPI = [
        'Terintegrasi lebih dari 30+ layanan kurir',
        'Lihat status pengiriman',
        'Tracking page custom '
    ]

    const orderAPI = [
        'Terintegrasi lebih dari 30+ layanan kurir',
        'Otomatis request penjemputan ke kurir pilihan',
        'Resi otomatis terbuat untuk siap dikirim'
    ]

    const storageList = [
        'Biaya dapat dihitung dalam harian',
        'Proses penyimpanan mudah tanpa repot',
        'Stok barang dari beberapa lokasi gudang Biteship'
    ]

    const fulfillmentList = [
        'Proses barang dari berbagai macam marketplace',
        'Stok terupdate secara real time',
        'Mudah dalam mengatur produk dari berbagai gudang',
        'Proses pengemasan yang cepat',
        'Mengatur semua pengiriman dari satu platform'
    ]

    const featureListView = (i) => {
        return (
            <div className=''>
                <span className='fas fa-check-circle' style={{color:'#03c1ae',marginTop:-2}}/>
                <text className='lead lh-150 ml-2 mt-1'>{i}</text>
            </div>
        )
    }
    if (loading) {
        return (
            <section>
                <div>
                    <div className="row no-gutters align-items-md-center text-center text-md-left">
                        <div className="col-lg-1"/>
                        <div className="order-1 ml-auto col-lg-4">
                        </div>
                        <div className="order-2 col-lg-7 mb-4 hover-scale-110">
                            <img alt="Biteship Shipment" src="/images/landing/make_order.png" className="img-fluid"/>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    return (
      <div style={{backgroundColor:'white'}}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Biteship: Pesan Berbagai Macam Kurir dalam Satu Platform</title>
                <meta name="description" content="Biteship adalah platform untuk melakukan pemesanan dari berbagai macam kurir dibangun untuk para pemilik bisnis.
                Terdapat lebih dari 20 Kurir Indonesia yang bergabung menjadi partner pengiriman. Kami membantu optimasi pengiriman Anda secara end-to-end." />
                <link rel="canonical" href="https://biteship.com" />
            </Helmet>
            <LandingPageNav/>

            <section className="slice">
                <div className="pt-5 container">
                        <h1 className="text-black lh-150"><strong>Harga Layanan</strong></h1>
                        <h2 className="text-violet-500 lh-150"><strong>Harga untuk semua ukuran bisnis.</strong></h2>
                        <p className="lead lh-180">
                            Pilih harga sesuai layanan yang Anda butuhkan. Cocok untuk bisnis yang baru mulai hingga melakukan ratusan ribu pesanan perharinya, Biteship ada untuk Anda.
                        </p>
                        <a href="https://dashboard.biteship.com/signin" onClick={() => onClickSignIn('Sign In Main Header')}>
                            <button className="btn btn-primary mt-5" >
                                {t('landing.headerButton')}
                            </button>
                        </a>
                        <a href="https://s.id/biteship-web-pricing-sales-section" onClick={() => onClickSignIn('Sign In Main Header')}>
                            <button className="btn btn-secondary mt-5 ml-3 border" >
                                {t('landing.contactSales')}
                            </button>
                        </a>
                </div>
            </section>

            <section className='slice'>
                <div className='container'>
                    <div className='card p-0 shadow'>
                        <div className='bg-violet-900 p-4 ' style={{borderTopLeftRadius:`.625rem`,borderTopRightRadius:`.625rem`}}>
                            <h2 className='text-white'>
                                <strong>
                                    Business Owner
                                </strong>
                            </h2>
                        </div>

                        <div className='px-5 pt-5'>
                            <h4 className='text-violet-900'>
                                <strong>
                                    Biteship Mobile App
                                </strong>
                            </h4>
                            <div className='row'>
                                <div className='col-12 col-md-8 '>
                                    <p className='lead lh-150'>
                                        Aplikasi Mobile App untuk Anda yang mulai melakukan pengiriman. Cocok untuk Anda yang mengatur pengiriman secara instan dan mudah.
                                    </p>
                                    { mobileApp.map(i => featureListView(i)) }
                                    <p className='lead lh-150 mt-2'>
                                        *Harga ditentukan tergantung asal dan tujuan beserta berat per pengiriman.
                                    </p>
                                    <a href="https://dashboard.biteship.com/signin" onClick={() => onClickSignIn('Sign In Main Header')}>
                                        <button className="btn btn-secondary border" >
                                            Download Aplikasi Biteship 
                                        </button>
                                    </a>
                                </div>
                                <div className='col-12 col-md-4 text-right p-4'>
                                   <h4 className='text-tiffany-500'>
                                       <strong>
                                            * Gratis
                                       </strong>
                                   </h4>
                                </div>
                            </div>
                            
                        </div>
                        <div className='px-5'><hr/></div>
                        <div className='px-5'>
                            <h4 className='text-violet-900'>
                                <strong>
                                    Shipping Dashboard
                                </strong>
                            </h4>
                            <div className='row'>
                                <div className='col-12 col-md-8 '>
                                    <p className='lead lh-150'>
                                        Aplikasi Desktop App untuk mengatur pengiriman dengan jumlah order yang lebih banyak. Cocok untuk digunakan dengan tim lebih dari 3 orang.                                    
                                    </p>
                                    { webApp.map(i => featureListView(i)) }
                                    <p className='lead lh-150 mt-2'>
                                        *Tidak dikenakan biaya layanan atau biaya berlangganan.
                                    </p>
                                    <a href="https://dashboard.biteship.com/signup" onClick={() => onClickSignIn('Sign In Main Header')}>
                                        <button className="btn btn-secondary border" >
                                            Daftar Dashboard Biteship
                                        </button>
                                    </a>
                                </div>
                                <div className='col-12 col-md-4 text-right p-4'>
                                   <h4 className='text-tiffany-500'>
                                       <strong>
                                            * Gratis
                                       </strong>
                                   </h4>
                                </div>
                            </div>
                        </div>
                        <div className='px-5'><hr/></div>
                        <div className='px-5'>
                            <h4 className='text-violet-900'>
                                <strong>
                                    Plugins                                
                                </strong>
                            </h4>
                            <div className='row pb-5'>
                                <div className='col-12 col-md-8 '>
                                    <p className='lead lh-150'>
                                        Aplikasi yang terintegrasi dengan channel penjualan favorit Anda.                                    
                                    </p>
                                    { plugins.map(i => featureListView(i)) }
                                    <div className='row align-items-center py-2'>
                                        <div className='col-2'>
                                            <img alt="Biteship WooCommerce Plugin" src="/images/landing/biteship-woo.png" className="img-fluid"/>
                                        </div>
                                        <div className='col-2'>
                                            <img alt="Biteship Shopify Plugin" src="/images/landing/biteship-shopify.png" className="img-fluid"/>
                                        </div>
                                        <div className='col-2'>
                                            <img alt="Biteship Magento Plugin" src="/images/landing/biteship-magento.png" className="img-fluid"/>
                                        </div>
                                        <div className='col-2'>
                                            <img alt="Biteship Prestashop Plugin" src="/images/landing/biteship-prestashop.png" className="img-fluid"/>
                                        </div>
                                        <div className='col-4'/>
                                    </div>
                                 
                                    <a href="/plugin" onClick={() => onClickSignIn('Sign In Main Header')}>
                                        <button className="btn btn-secondary border" >
                                            Dapatkan Plugins
                                        </button>
                                    </a>
                                </div>
                                <div className='col-12 col-md-4 text-right p-4'>
                                   <h4 className='text-tiffany-500'>
                                       <strong>
                                            Mulai dari Rp 49.000
                                       </strong>
                                   </h4>
                                   <p className='lead'>
                                       per bulan. Gratis 3 bulan untuk pembayaran per tahun
                                   </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='card p-0 shadow mt-4'>
                        <div className='bg-violet-900 p-4 ' style={{borderTopLeftRadius:`.625rem`,borderTopRightRadius:`.625rem`}}>
                            <h2 className='text-white'>
                                <strong>
                                    Developers
                                </strong>
                            </h2>
                        </div>

                        <div className='px-5 pt-5'>
                            <h4 className='text-violet-900'>
                                <strong>
                                    Maps Search API
                                </strong>
                            </h4>
                            <div className='row'>
                                <div className='col-12 col-md-8 '>
                                    <p className='lead lh-150'>
                                        Pencarian kodepos, kecamatan dan nama kota dengan mudah.                                    
                                    </p>
                                    { mapsSearchAPI.map(i => featureListView(i)) }
                                    <a href="/docs/api" onClick={() => onClickSignIn('Sign In Main Header')}>
                                        <button className="btn btn-secondary border mt-2" >
                                            Details for Maps Search API                                        
                                        </button>
                                    </a>
                                </div>
                                <div className='col-12 col-md-4 text-right p-4'>
                                    <h4 className='text-tiffany-500'>
                                       <strong>
                                            Rp 99.000
                                       </strong>
                                   </h4>
                                   <p className='lead'>
                                        per 100.000 API request                                   
                                    </p>
                                </div>
                            </div>
                            
                        </div>
                        <div className='px-5'><hr/></div>
                        <div className='px-5'>
                            <h4 className='text-violet-900'>
                                <strong>
                                    Rates API                                
                                </strong>
                            </h4>
                            <div className='row'>
                                <div className='col-12 col-md-8 '>
                                    <p className='lead lh-150'>
                                        Pencarian harga kurir (ongkos kirim).                                    
                                    </p>
                                    { ratesAPI.map(i => featureListView(i)) }

                                    <a href="/docs/api/rates" onClick={() => onClickSignIn('Sign In Main Header')}>
                                        <button className="btn btn-secondary border mt-2" >
                                            Details for Rates API
                                        </button>
                                    </a>
                                </div>
                                <div className='col-12 col-md-4 text-right p-4'>
                                    <h4 className='text-tiffany-500'>
                                       <strong>
                                            Rp 99.000
                                       </strong>
                                   </h4>
                                   <p className='lead'>
                                        per 10.000 API request                                   
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='px-5'><hr/></div>
                        <div className='px-5'>
                            <h4 className='text-violet-900'>
                                <strong>
                                    Tracking API                                
                                </strong>
                            </h4>
                            <div className='row '>
                                <div className='col-12 col-md-8 '>
                                    <p className='lead lh-150'>
                                        Tracking resi dari berbagai macam kurir                                    
                                    </p>
                                    { trackingAPI.map(i => featureListView(i)) }
                                 
                                    <a href="/docs/api/trackings" onClick={() => onClickSignIn('Sign In Main Header')}>
                                        <button className="btn btn-secondary border mt-2" >
                                            Details for Tracking API
                                        </button>
                                    </a>
                                </div>
                                <div className='col-12 col-md-4 text-right p-4'>
                                    <h4 className='text-tiffany-500'>
                                       <strong>
                                            Rp 99.000
                                       </strong>
                                   </h4>
                                   <p className='lead'>
                                        per 10.000 API request                                   
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='px-5'><hr/></div>
                        <div className='px-5'>
                            <h4 className='text-violet-900'>
                                <strong>
                                    Order API                                
                                </strong>
                            </h4>
                            <div className='row pb-5'>
                                <div className='col-12 col-md-8 '>
                                    <p className='lead lh-150'>
                                        Buat resi otomatis dan dijemput langsung oleh kurir.                                    
                                    </p>
                                    { orderAPI.map(i => featureListView(i)) }
                                    <p className='lead lh-150 mt-2'>
                                        *Harga ditentukan tergantung asal dan tujuan beserta berat per pengiriman.
                                    </p>
                                    <a href="/docs/api/orders" onClick={() => onClickSignIn('Sign In Main Header')}>
                                        <button className="btn btn-secondary border" >
                                            Details for Order API
                                        </button>
                                    </a>
                                </div>
                                <div className='col-12 col-md-4 text-right p-4'>
                                    <h4 className='text-tiffany-500'>
                                       <strong>
                                            * Gratis
                                       </strong>
                                   </h4>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className='card p-0 shadow mt-4'>
                        <div className='bg-violet-900 p-4 ' style={{borderTopLeftRadius:`.625rem`,borderTopRightRadius:`.625rem`}}>
                            <h2 className='text-white'>
                                <strong>
                                    Fulfillment
                                </strong>
                                <h5 className='text-tiffany-500'>
                                    Partnership with Gudang.io
                                </h5>
                            </h2>
                        </div>

                        <div className='px-5 pt-5 '>
                            <h4 className='text-violet-900'>
                                <strong>
                                    Storage
                                </strong>
                            </h4>
                            <div className='row'>
                                <div className='col-12 col-md-8 '>
                                    <p className='lead lh-150'>
                                        Layanan penyimpanan barang untuk kebutuhan bisnis Anda.
                                    </p>
                                    { storageList.map(i => featureListView(i)) }
                                    <a href="https://gudang.io" onClick={() => onClickSignIn('Sign In Main Header')}>
                                        <button className="btn btn-secondary border mt-2" >
                                            Details untuk layanan Storage                                
                                        </button>
                                    </a>
                                </div>
                                <div className='col-12 col-md-4 text-right p-4'>
                                    <h4 className='text-tiffany-500'>
                                       <strong>
                                            Rp 500
                                       </strong>
                                   </h4>
                                   <p className='lead'>
                                        per 1.000 cm cubic
                                    </p>
                                </div>
                            </div>
                            
                        </div>
                        <div className='px-5'><hr/></div>
                        <div className='px-5'>
                            <h4 className='text-violet-900'>
                                <strong>
                                    Rates API                                
                                </strong>
                            </h4>
                            <div className='row  pb-5'>
                                <div className='col-12 col-md-8 '>
                                    <p className='lead lh-150'>
                                        Pencarian harga kurir (ongkos kirim).                                    
                                    </p>
                                    { fulfillmentList.map(i => featureListView(i)) }

                                    <a href="https://gudang.io" onClick={() => onClickSignIn('Sign In Main Header')}>
                                        <button className="btn btn-secondary border mt-2" >
                                            Details untuk Pick and Pack
                                        </button>
                                    </a>
                                </div>
                                <div className='col-12 col-md-4 text-right p-4'>
                                    <h4 className='text-tiffany-500'>
                                       <strong>
                                            Rp 1.000
                                       </strong>
                                   </h4>
                                   <p className='lead'>
                                        per barang terproses                               
                                    </p>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div style={{height:320}}/>
            </section>

            <Section/>
            <FooterLandingPage/>
      </div>

    );
};

export default Landing;
